import { matchPath } from 'react-router-dom';
import { ContextResolver } from '../types';

const OPPORTUNITY_LIST_FILTER_KEYS = ['search', 'owner', 'score', 'stage', 'createdAt', 'amount', 'tags'];
const OPPORTUNITY_LIST_ROUTE_PATTERN = '/:agentId/opportunities/:pipelineId/view/list';
const LIST_CAPABILITIES = [
    'View all opportunities in a table',
    'Create new opportunities',
    'Update opportunity stage',
    'Search and filter opportunities',
];
const OPPORTUNITY_DETAILS_CAPABILITIES = [
    'Review and update opportunity details',
    'Edit key opportunity attributes',
    'Record context and follow-up notes',
    'Organize and update opportunity TODOs',
];

const opportunitiesListResolver: ContextResolver = {
    match: ({ pathname }) => Boolean(matchPath(OPPORTUNITY_LIST_ROUTE_PATTERN, pathname)),
    resolve: ({ pathname, searchParams }) => {
        const routeMatch = matchPath(OPPORTUNITY_LIST_ROUTE_PATTERN, pathname);
        const pipelineId = routeMatch?.params?.pipelineId || '';
        const appliedFilters = OPPORTUNITY_LIST_FILTER_KEYS.reduce((filters: string[], key) => {
            const value = searchParams.get(key);
            if (!value) {
                return filters;
            }
            return [...filters, `${key}: ${value}`];
        }, []);
        const opportunityId = searchParams.get('showOpportunity') || '';

        return {
            description: 'User is working in the opportunities list to review and manage pipeline opportunities in a table.',
            capabilities: opportunityId ? OPPORTUNITY_DETAILS_CAPABILITIES : LIST_CAPABILITIES,
            ids: {
                ...(pipelineId ? { pipelineId } : {}),
                ...(opportunityId ? { opportunityId } : {}),
            },
            hints: [
                'The user is viewing the opportunities list in table format.',
                ...(pipelineId ? [`Pipeline ${pipelineId} is selected in this list view.`] : []),
                ...(opportunityId ? [`Opportunity ${opportunityId} is currently open in the details drawer.`] : []),
                ...(appliedFilters.length > 0
                    ? [`The list currently has active filters: ${appliedFilters.join(', ')}.`]
                    : ['No list filters are currently applied.']),
            ],
        };
    },
};

export default opportunitiesListResolver;
